import { getAssetUrl } from '../../Common/Utils/assetUrl';
export const mapB2CTenantToLanding = (tenantData) => {
  const theme = tenantData?.theme || {};
  const topBar = tenantData?.topBar || {};
  const header = tenantData?.header || {};
  const footer = tenantData?.footer || {};
  const hero = tenantData?.hero || {};

  return {
      isPreview: tenantData?.isPreview ?? false,
    companyId:   tenantData?.companyId,
    branchId:    tenantData?.branchId,
    userId:      tenantData?.userId,
    logoUrl:     getAssetUrl(tenantData?.branding?.logoUrl) || '/assets/images/logo.png',
    companyName: tenantData?.branding?.companyName || 'Travel Agency',
    brandName:   tenantData?.branding?.brandName   || 'Travel Agency',
    email:    tenantData?.branding?.email    || 'info@travelagency.com',
    phones:   tenantData?.branding?.phones   || '9000000000',
    whatsapp: tenantData?.branding?.whatsapp || '9000000000',
    socials:  tenantData?.branding?.socials  || {},
     companyData:     tenantData?.companyData || {},
     seo: tenantData?.seo || {},
    themeColor1: theme.themeColor1 || theme.themecolor1,
    themeColor2: theme.themeColor2 || theme.themecolor2,
    themeColor3: theme.themeColor3 || theme.themecolor3,
    themeColor4: theme.themeColor4 || theme.themecolor4,
    themeColor5: theme.themeColor5 || theme.themecolor5,
    topBarBg:   topBar.bgColor   || '#4f46e5',
    topBarText: topBar.textColor || '#ffffff',
    headerBg:   header.bgColor   || '#ffffff',
    headerText: header.textColor || '#0f172a',
    footerBg:   footer.bgColor   || '#1e1b4b',
    footerText: footer.textColor || '#ffffff',
    headingFont: tenantData?.branding?.headingFont || 'Plus Jakarta Sans',
    bodyFont:    tenantData?.branding?.bodyFont    || 'Inter',
    heroData: {
      flights:     { title: hero.flights?.title     || 'Search Flights',   subTitle: hero.flights?.subTitle     || 'Best fares guaranteed.' },
      hotels:      { title: hero.hotels?.title      || 'Search Hotels',    subTitle: hero.hotels?.subTitle      || 'Handpicked stays for you.' },
      holidays:    { title: hero.holidays?.title    || 'Explore Holidays', subTitle: hero.holidays?.subTitle    || 'Curated packages.' },
      sightseeing: { title: hero.sightseeing?.title || 'Find Activities',  subTitle: hero.sightseeing?.subTitle || 'Discover experiences.' },
    },
  };
};

export const getB2CColors_T38 = (landingData) => {
  console.log('landingData:', landingData);
  const c1 = landingData.themeColor1 || '#4f46e5';
  return {
    theme1:     c1,
    theme2:     landingData.footerBg    || '#1e1b4b',
    theme3:     landingData.headerBg    || '#ffffff',
    theme4:     landingData.themeColor4 || '#f8fafc',
    theme5:     landingData.themeColor5 || '#0f172a',
    accent:     landingData.themeColor2 || '#f59e0b',
    headerText: landingData.headerText  || '#0f172a',
    footerText: landingData.footerText  || '#ffffff',
    topBarBg:   landingData.topBarBg    || '#4f46e5',
    topBarText: landingData.topBarText  || '#ffffff',
  };
};
